import axios, { AxiosResponse } from 'axios';
import { apiClient } from '../endpoints';
import { User } from '../users';
import { VehicleType } from './vehiclesTypes';

export interface UtilityVehicle {
    _id: string;
    designation: string;
    codeProC: string;
    plateNumber: string;
    userId?: User;
    crudStatus: number;
    price?: number;
    priceType?: number;
    vehicleTypeId: VehicleType;
    usageCount?: {
        total: number;
        gnrUtilityVehiclesUsage: number;
    };
    updatedAt?: string;
    createdAt?: string;
    baseName: string;
}

export interface UtilityVehiclesResponse {
    message: string;
    data: UtilityVehicle[];
}

export interface UtilityVehicleResponse {
    message: string;
    data: UtilityVehicle;
}

export interface GetUtilityVehiclesQueries {
    active?: boolean;
    withUsage?: boolean;
}

export interface CreateUtilityVehicleBody {
    designation: string;
    codeProC: string;
    plateNumber: string;
    userId?: string | null;
    price?: number | null;
    priceType?: number | null;
    crudStatus?: number;
    vehicleTypeId: string;
    baseName: string;
}

export interface UpdateUtilityVehicleBody {
    designation?: string;
    codeProC?: string;
    plateNumber?: string;
    userId?: string | null;
    price?: number | null;
    priceType?: number | null;
    crudStatus?: number;
    vehicleTypeId?: string;
    baseName?: string;
}

export const getAllUtilityVehicles = async (
    queries?: GetUtilityVehiclesQueries
): Promise<UtilityVehiclesResponse> => {
    try {
        const response: AxiosResponse<UtilityVehiclesResponse> = await apiClient.get('/utility-vehicles', { params: queries });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export const getUtilityVehicleById = async (id: string): Promise<UtilityVehicleResponse> => {
    try {
        const response: AxiosResponse<UtilityVehicleResponse> = await apiClient.get(`/utility-vehicles/${id}`);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export const createUtilityVehicle = async (data: CreateUtilityVehicleBody): Promise<UtilityVehicleResponse> => {
    try {
        const response: AxiosResponse<UtilityVehicleResponse> = await apiClient.post('/utility-vehicles', data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export const updateUtilityVehicle = async (
    id: string,
    data: UpdateUtilityVehicleBody
): Promise<UtilityVehicleResponse> => {
    try {
        const response: AxiosResponse<UtilityVehicleResponse> = await apiClient.patch(`/utility-vehicles/${id}`, data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};
